// Helper pour lire la couleur d'accent de marque à l'exécution depuis la
// variable CSS `--accent-hex` posée par `useBrandBootstrap` au boot.
//
// Pourquoi pas juste `var(--accent-hex)` en prop Recharts ? Parce que certains
// props (ex. `activeDot={{ fill: ... }}`) passent l'objet tel quel à un SVG
// attribute qui ne résout pas toujours `var()` correctement selon la version.
// Lire la valeur calculée une fois par render est plus sûr et cohérent.
//
// SSR-safe : retourne le fallback `#3E63DD` si `window` n'est pas défini.

const FALLBACK_ACCENT = '#3E63DD';

export function getAccentHex(): string {
  if (typeof window === 'undefined') return FALLBACK_ACCENT;
  const value = getComputedStyle(document.documentElement).getPropertyValue('--accent-hex').trim();
  return value || FALLBACK_ACCENT;
}
